
<div class="session bg-primary">
  <div class="session-content">
    <div class="flex-box-monkey">
      <mat-card class="flex-card">
        <mat-card-content>
          <app-choose-subscription-packs [redirect]="true"></app-choose-subscription-packs>
          <p class="text-center">
            <a data-ci="logout" class="flex-link" (click)="logout()">Logout</a>
          </p>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
